import type { TableTabResponse } from '../../types';

export function isTableTabEmpty(data: TableTabResponse): boolean {
  const tableRowsNull = data.tableRows === null;
  const groupsNull = data.groups === null;
  const knockoutNull = data.knockout === undefined || data.knockout === null;

  return tableRowsNull && groupsNull && knockoutNull;
}
